export const splitToChapterGroups = (arr: string[], columnsNumber: number) => {
	const chapterGroups = [];
	const groupSize = arr.length > columnsNumber ? Math.ceil(arr.length / columnsNumber) : 1;

	for (let i = 0; i < arr.length; i += groupSize) {
		chapterGroups.push(arr.slice(i, i + groupSize));
	}

	return { chapterGroups, groupSize };
};

export const insertInArrayByIndex = (arr: string[], value: string, index: number) => {
	return [...arr.slice(0, index), value, ...arr.slice(index)];
};

export const getRoomNameByLocation = (pathname: string) => {
	const [path, _] = pathname.split('?');
	const params = path.split('/');

	switch (true) {
		case path.includes('pages'): {
			const index = params.indexOf('pages');
			return `${params[index + 1]}`;
		}

		case path.includes('page_groups'): {
			const index = params.indexOf('page_groups');
			return `${params[index + 1]}`;
		}

		case path.includes('chapters'): {
			const index = params.indexOf('chapters');
			return `${params[index + 1]}`;
		}

		case path.includes('courses'): {
			return 'toc';
		}

		default:
			break;
	}
};

export const sanitizeCourseId = (courseId: string) => {
	return +courseId.split('-')[0];
};
